import dayjs from "dayjs";
import _ from "lodash";

const generateHours = (start = 6, end = 20, interval = 30, truncate = true) => {
  let hours = [];
  for (let hour = start; hour < end; hour++) {
    hours.push(dayjs().hour(hour).minute(0).format("h:mm A"));
    hours.push(dayjs().hour(hour).minute(interval).format("h:mm A"));
  }
  if (truncate) {
    hours = _.initial(hours);
  }
  return hours;
};

export { generateHours };
